<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import List from "../../../components/list";
import { paymentService } from "../../../services/paymentservice/payment.service";
import { settingService } from "../../../services/settingservice/setting.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Payment Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Area,
    Select,
    Search,
    List
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Payment",
      breadCrumb: {},
      currency: "",
      paymentListData: {},
      paymentData: null,
      paymentMethodData: {},
      currencyData: {},

      dataTotal: 0,

      dataRef: 0,
      dataCode: '',
      dataCustomer: 0,
      dataPaymentAccount: 0,
      dataProject: 0,
      dataProperty: 0,
      dataCurrency: 0,
      dataAmount: 0,
      dataPaid: 0,
      dataPay: 0,
      dataBalance: 0,
      dataPenalty: 0,
      dataDiscount: 0,
      dataPaymentTerm: 0,
      dataPaymentMethod: 0,
      dataPaymentStatus: 0,
      dataNotation: ''

    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingCurrencyData();
    this.loadingPaymentMethodData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    this.dataCurrency = 1;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    }  
    // else if('propertyid' in this.$route.query) {
      
    // }

  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      paymentService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.paymentData = response;

          this.dataRef = this.paymentData.data.ref_id;
          this.dataCode = this.paymentData.data.code;
          this.dataCustomer = this.paymentData.data.customer_id;
          this.dataPaymentAccount = this.paymentData.data.payment_account_id;
          this.dataProject = this.paymentData.data.project_id;
          this.dataProperty = this.paymentData.data.property_id;
          this.dataCurrency = this.paymentData.data.currency_id;
          this.dataAmount = this.paymentData.data.amount;
          this.dataPaid = this.paymentData.data.paid;
          this.dataPay = this.paymentData.data.pay;
          this.dataBalance = this.paymentData.data.balance;
          this.dataPenalty = this.paymentData.data.penalty;
          this.dataDiscount = this.paymentData.data.discount;
          this.dataPaymentTerm = this.paymentData.data.payment_term_id;
          this.dataPaymentMethod = this.paymentData.data.payment_method_id;
          this.dataPaymentStatus = this.paymentData.data.payment_status_id;
          this.dataNotation = this.paymentData.data.notation;
          this.dataTotal = this.paymentData.data.amount + this.paymentData.data.penalty - this.paymentData.data.discount;

          // console.log(this.dataCurrency);
        
        });
    },
    loadingCurrencyData: function() {
      // this.fetchingStats = false;
      settingService.getIDTypeList()
        .then(response => {
          // this.fetchingStats = true;
          this.idTypeData = response;
        });
    },

    loadingPaymentMethodData: function() {
      // this.fetchingStats = false;
      settingService.getGenderList()
        .then(response => {
          // this.fetchingStats = true;
          this.genderData = response;
        });
    },
    clearForm: function() {
      this.dataRef = 0;
      this.dataCode = '';
      this.dataCustomer = 0;
      this.dataPaymentAccount = 0;
      this.dataProject = 0;
      this.dataProperty = 0;
      this.dataCurrency = 0;
      this.dataAmount = 0;
      this.dataPaid = 0;
      this.dataPay = 0;
      this.dataBalance = 0;
      this.dataPenalty = 0;
      this.dataDiscount = 0;
      this.dataPaymentTerm = 0;
      this.dataPaymentMethod = 0;
      this.dataPaymentStatus = 0;
      this.dataNotation = '';
      this.dataTotal = 0;
    },
    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "loan-list"
          });

        }
      });

      
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let payment = {
        ref_id: this.dataRef,
        code: this.dataCode,
        customer_id: this.dataCustomer,
        payment_account_id: this.dataPaymentAccount,
        project_id: this.dataProject,
        property_id: this.dataProperty,
        currency_id: this.dataCurrency,
        amount: this.dataAmount,
        paid: this.dataPaid,
        pay: this.dataPay,
        balance: this.dataBalance,
        penalty: this.dataPenalty,
        discount: this.dataDiscount,
        payment_term_id: this.dataPaymentTerm,
        payment_method_id: this.dataPaymentMethod,
        payment_status_id: this.dataPaymentStatus,
        notation: this.dataNotation,

      };

      // console.log(JSON.stringify(loan));

      if(this.isAdd) {
        paymentService.insert(payment)
         .then(response => {
           this.tryingToSubmit = false;

           console.log(response);

           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "payment-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(loan));
        paymentService.update(this.$route.params.id, payment)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "payment-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },
    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    }, 

  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('payment.list'),
        href: '/general/payment',
      }, {
        text: $t('payment.new'),
        active: true
      }]" :title="this.isAdd ? $t('payment.new') : $t('payment.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('payment.list'),
        href: '/general/payment',
      }, this.breadCrumb]" :title="this.isAdd ? $t('payment.new') : $t('payment.edit')" />
    </div>
    <Loader :loading="fetchingStats">

    <b-form  @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="dataCode"
                    :label="'loan.code'" 
                    :require="true"
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'pay_date'"
                    v-model="dataDate"
                    :label="'general.date'"  />
                </div>
                <div class="col-md-6">
                  <Search 
                    :id="'customer_id'"
                    :text2="'name_en'"
                    :auto="true"
                    v-model="dataCustomer"
                    :list="this.customerData"
                    :require="true"
                    :label="'customer.text'"  />
                </div>
                
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select
                    @change="currencyChanged" 
                    :id="'currency_id'"
                    :auto="true"
                    :text2="'name_en'"
                    v-model="dataCurrency"
                    :list="this.currencyData"
                    :label="'property.currency'"
                     /> 
                </div>
                <div class="col-md-6">
                  <Select
                    :id="'payment_method_id'"
                    :auto="true"
                    :text2="'name_en'"
                    v-model="dataCurrency"
                    :list="this.currencyData"
                    :label="'payment.payment-method'"
                     /> 
                </div>
              </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="mb-1">
                  <h4 class="card-title">{{$t('payment.payment-schedule')}}</h4>
                  <hr/>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <List v-bind:dataList="paymentListData" 
                    v-bind:filter="{}"
                    v-bind:fill="false"
                    v-bind:updating="true" 
                    v-bind:showLoading="false"
                    v-bind:navigate="pageNavigate"
                    v-bind:fields="[ `code: ${$t('payment.contact')}`, `loan_date: ${$t('general.date')}`, `customer: ${$t('payment.amount')}`, 
                      `property: ${$t('payment.paid-amount')}`, `currency_en: ${$t('payment.pay-amount')}`]" />
                </div>
              </div>

              
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3"></div>
              <div class="col-lg-3">
                <div class="mb-4"></div>
                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
  
              </div>
              <div class="col-lg-6">
                  <div class="col-md-12">
                    <Input 
                      :type="'number'"
                      :id="'amount'"
                      :disabled="true"
                      v-model="dataAmount"
                      :label="'loan.amount'" 
                      :last="'general.usd'"
                      /> 
                  </div>
                  <div class="col-md-12">
                    <Input 
                      :type="'number'"
                      :id="'penalty'"
                      v-model="dataPenalty"
                      :label="'payment.penalty'" 
                      :last="'general.usd'"
                      /> 
                  </div>
                  <div class="col-md-12">
                    <Input 
                      :type="'number'"
                      :id="'discount'"
                      v-model="dataDiscount"
                      :label="'payment.discount'" 
                      :last="'general.usd'"
                      /> 
                  </div>
                  <div class="col-md-12">
                    <Input 
                      :type="'number'"
                      :id="'total'"
                      :disabled="true"
                      v-model="dataTotal"
                      :label="'payment.total-amount'" 
                      :last="'general.usd'"
                      /> 
                  </div>
                  <div class="col-md-12">
                    <Area 
                      :rows="4"
                      :id="'notation'"
                      v-model="dataNotation"
                      :label="'loan.notation'"  />
                  </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </b-form> 
  
    </Loader>
  </Layout>
</template>